import { render } from "./PrivacyPage.vue?vue&type=template&id=2e16490a&scoped=true"
import script from "./PrivacyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&lang=js"

import "./PrivacyPage.vue?vue&type=style&index=0&id=2e16490a&scoped=true&lang=css"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e16490a"]])

export default __exports__